// react
import { useContext, useEffect, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Pagination, ReconciliationItem } from '../../../../../@types';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextProject } from '../../Project.context';

// hooks
import { useFetch } from '../../../../../hooks/useFetch';

// mui
import { Container, Grid, Paper, Typography } from '@mui/material';

// dialogs
import { DialogAddReconciliationItem } from '../../../../dialogs/DialogAddReconciliationItem/DialogAddReconciliationItem';

// tables
import { TableBasicReconciliationItems } from '../../../../../components/tables/basic/TableBasicReconciliationItems/TableBasicReconciliationItems';

// utils
import { defaultPagination } from '../../../../../utils/defaults';

export const ReconciliationItems = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// params
	const paramPage = Number(searchParams.get('page') || 1);
	const paramDialog = searchParams.get('dialog');

	// state
	const [reconciliationItems, setReconciliationItems] = useState<ReconciliationItem[]>([]);
	const [pagination, setPagination] = useState<Pagination>({
		...defaultPagination,
		perPage: 5,
	});

	// fetch reconciliation items (both default and project-specific)
	const urlReconciliationItems = `${process.env.REACT_APP_API_URL}/reconciliation-items?project=${project?.id},null&page=${paramPage}&limit=${pagination.perPage}`;

	const { isLoading, refetch: refetchReconciliationItems } = useFetch({
		isEnabled: Boolean(project),
		url: urlReconciliationItems,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setReconciliationItems(res.data);
			}

			if (res.pagination) {
				setPagination(res.pagination);
			}
		},
	});

	// refetch reconciliation items when page param changes
	useEffect(() => {
		refetchReconciliationItems();
	}, [paramPage, refetchReconciliationItems]);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
							};
						}}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h3">{t('reconciliationItems')}</Typography>
							</Grid>
							<Grid item xs={12}>
								<TableBasicReconciliationItems
									borderRadius={2}
									color="grey"
									data={reconciliationItems}
									hasBorder={true}
									hasDividers={true}
									isLoading={isLoading}
									refetchReconciliationItems={refetchReconciliationItems}
									TableFooterProps={{
										numShowing: reconciliationItems.length,
										pagination,
									}}
								/>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
			<DialogAddReconciliationItem
				isOpen={paramDialog === 'addReconciliationItem'}
				onClose={() => {
					searchParams.delete('dialog');
					setSearchParams(searchParams);
				}}
				onSuccess={() => {
					refetchReconciliationItems();
					searchParams.delete('dialog');
					setSearchParams(searchParams);
				}}
			/>
		</Container>
	);
};
